export const driverAttendApiNm = {
  getDriverAttendTable: "/driver-attend/getDriverAttendTable",
  getDriverAttendTableWithHoliday: "/driver-attend/getDriverAttendTableWithHoliday",
  getDriverAttendStatus: "/driver-attend/getDriverAttendStatus",
  getDriverCheckIn: "/driver-attend/getDriverCheckIn",
  getHoliday: "/driver-attend/getHoliday",
  updateDriverAttendCols: "/driver-attend/updateDriverAttendCols",
  insertDuplicateUpdateBulkDriverAttend: "/driver-attend/insertDuplicateUpdateBulkDriverAttend",
  insertDriverAttendFromJobOrder: "/driver-attend/insertDriverAttendFromJobOrder",
  updateHolidayCols: "/driver-attend/updateHolidayCols",
  insertHoliday: "/driver-attend/insertHoliday",
  deleteHoliday: "/driver-attend/deleteHoliday",
}

export const holidayColNm = {
  HdayDte: "วันที่",
  HdayNm: "ชื่อวันหยุด",
  Dscp: "หมายเหตุ",
}